export const formatCompanySizeLabel = (value?: string | null): string => {
  if (!value) return 'N/A';
  const trimmed = value.trim();
  if (!trimmed) return 'N/A';

  return trimmed.replace(/\d[\d,]*/g, (token) => {
    const numericValue = Number(token.replace(/,/g, ''));
    if (!Number.isFinite(numericValue)) return token;
    return numericValue >= 1000 ? numericValue.toLocaleString() : String(numericValue);
  });
};

